import { Injectable } from '@angular/core';
import { SecurityService } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LogService } from '../../Core/Abstract/log.service';

import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';

@Injectable()
export class HomeService extends SecurityService{

     constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService) {
        super(http,configService,eventsEmitterService, router ,logger);
    }

    public getCurrentUser(): Observable<any>{
        //let cookie = localStorage.getItem('home_cookie') == null ? '' : localStorage.getItem('home_cookie');
        let serviceUrl = this.baseUrl   + 'home/companyHeader'
        return this.http.get(serviceUrl).pipe(map(
            response =>   {      
                let body = response;
                localStorage.setItem("home_info", JSON.stringify(body));
                localStorage.setItem('home_cookie', body['cookieId'] )
            }
        ),catchError(super.handleError));
    }

}